export default "__VITE_ASSET__B1lk_gTR__"